export default __webpack_public_path__ + "static/media/computers.819d7d2e.png";